import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	routes: [
		{path: '/',redirect:'index'},
		{path: '/index',component:()=>import("./pages/index.vue"),name:"跳转"},
		{path: '/templateOne',component:()=>import("./pages/templateOne.vue"),name:"活动"},
		{path: '/activity',component:()=>import("./pages/activity.vue"),name:"活动详情"},
		{path: '/signActivity',component:()=>import("./pages/signActivity.vue"),name:"打卡活动"},
		{path: '/sealRuleEdit',component:()=>import("./pages/sealRuleEdit.vue"),name:"录入电子印章规则"},
		{path: '/sealPointsInput',component:()=>import("./pages/sealPointsInput.vue"),name:"录入电子印章点位"},
		{path: '/sealTest',component:()=>import("./pages/sealTest.vue"),name:"印章相似度测试"},
		{path: '/sealTestCommon',component:()=>import("./pages/sealTestCommon.vue"),name:"印章相似度测试(通用版)"},
		{path: '/sealTouchDetect',component:()=>import("./pages/sealTouchDetect.vue"),name:"印章触点检测"},
		{path: '/coupons',component:()=>import("./pages/coupons.vue"),name:"券票"},
		{path: '/code',component:()=>import("./pages/code.vue"),name:"新年福利待领取"},
		// 活动跳转与模板页（与小程序同一配置双端使用，打卡坐标系一致）
		{path: '/loading/activityRedirect',component:()=>import("./pages/loading/activityRedirect.vue"),name:"活动跳转"},
		{path: '/template/activity3',component:()=>import("./pages/template/activity3.vue"),name:"活动模板3首页"},
		{path: '/template/activity3-1',component:()=>import("./pages/template/activity3-1.vue"),name:"活动模板3打卡"}
	]
})
